'use client'

import { cn } from '@brew/ui/cn'
import type { CSSProperties } from 'react'
import { MK_SMALL } from '@/components/marketing/home/home-layout'
import { useEmailAuditCopy } from './use-email-audit-copy'

/** Each line arrives this long after the one before, while the audit runs. */
const STEP_DELAY_MS = 1100

/**
 * The running state: one line per check, arriving on a CSS stagger with a
 * radiating dot, so the wait reads as work in progress. Pure CSS; reduced
 * motion shows every line at once.
 */
export function EmailAuditProgress({ className }: { className?: string }) {
  const { progress } = useEmailAuditCopy()
  return (
    <ol
      aria-label={progress.label}
      className={cn('flex flex-col gap-3', className)}
    >
      {progress.steps.map((step, index) => (
        <li
          key={step}
          style={
            { animationDelay: `${index * STEP_DELAY_MS}ms` } as CSSProperties
          }
          className="flex items-center gap-3 motion-safe:animate-mk-card-in"
        >
          <span className="relative grid size-4 shrink-0 place-items-center">
            <span className="absolute size-2 rounded-full bg-mk-accent/40 motion-safe:animate-mk-radiate" />
            <span className="size-2 rounded-full bg-mk-accent" />
          </span>
          <span className={cn(MK_SMALL, 'text-mk-ink-2')}>{step}…</span>
        </li>
      ))}
    </ol>
  )
}
